var helpers = {
	windowHeight: jQuery(window).height(),
	init: function () {
		jQuery(window).on(
			'resize',
			theme.helpers.throttle(function () {
				theme.helpers.windowHeight = jQuery(window).height();
				jQuery(window).trigger('scroll');
			}, 250)
		);
	},

	initializeDateRangePicker(target, startDate, endDate, minDate, customOptions = {}) {
		const self = this;

		const defaultOptions = {
			locale: {
				format: 'DD. MM. YYYY',
				separator: ' – ',
				applyLabel: pctVars.l18n.apply,
				cancelLabel: pctVars.l18n.cancel,
				fromLabel: pctVars.l18n.from,
				toLabel: pctVars.l18n.to,
				customRangeLabel: 'Custom',
				weekLabel: 'W',
				daysOfWeek: pctVars.l18n.weekDays,
				monthNames: pctVars.l18n.months,
				firstDay: 1,
			},
			opens: 'left',
			startDate: startDate,
			endDate: endDate,
			minDate: minDate,
		};

		const finalOptions = jQuery.extend(true, {}, defaultOptions, customOptions);

		const $input = jQuery(target);

		// Initialize the date picker
		$input.daterangepicker(finalOptions);

		// Close datepicker when clicking outside
		const closeOnOutsideClick = (e) => {
			const $container = jQuery('.daterangepicker');
			if (
				$container.length &&
				!$container.is(e.target) &&
				$container.has(e.target).length === 0 &&
				!$input.is(e.target) &&
				$input.has(e.target).length === 0
			) {
				$input.data('daterangepicker').hide();
			}
		};

		// Bind the document click
		jQuery(document).on('mousedown.daterangepicker-outside', closeOnOutsideClick);

		// Optional: Clean up the listener when picker is destroyed
		$input.on('destroy.daterangepicker', () => {
			jQuery(document).off('mousedown.daterangepicker-outside');
		});
	},

	// Function to format the date
	formatDate: function (date, daysOfWeek) {
		return date.format('ddd DD. MM.').replace('Sun', daysOfWeek[0]).replace('Mon', daysOfWeek[1]).replace('Tue', daysOfWeek[2]).replace('Wed', daysOfWeek[3]).replace('Thu', daysOfWeek[4]).replace('Fri', daysOfWeek[5]).replace('Sat', daysOfWeek[6]);
	},

	throttle: function (fn, wait) {
		var time = Date.now();
		return function () {
			if (time + wait - Date.now() < 0) {
				fn();
				time = Date.now();
			}
		};
	},

	setCookie(name, value, days) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	},

	getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},

	eraseCookie(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	},

	isOnScreen: function( element ){
		var win = jQuery(window);
	
		var viewport = {
			top : win.scrollTop(),
			left : win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();
	
		var bounds = element.offset();
		bounds.right = bounds.left + element.outerWidth();
		bounds.bottom = bounds.top + element.outerHeight();
	
		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	},

	showMessage: function( message, element, elementClass, canDismiss = false, placement = 'append' ) {
		const self = this;

		const id 			= "id" + Math.random().toString(16).slice(2);
		const removeLink 	= ( canDismiss ) ? '<a href="#" data-sikmon="closeDelete"></a>' : '';
		const htmlData 		= `<div id="${id}" class="${elementClass}"><p>${message}</p>${removeLink}</div>`;
		const placeTypes 	= [ 'append', 'prepend', 'after', 'before' ];

		if( ! placeTypes.includes( placement ) ) {
			console.log( 'wrong type of place' );
			return false;
		}
		
		if( placement == 'append' ) jQuery( element ).append( htmlData );
		if( placement == 'prepend' ) jQuery( element ).prepend( htmlData );
		if( placement == 'after' ) jQuery( htmlData ).insertAfter( element );
		if( placement == 'before' ) jQuery( htmlData ).insertBefore( element );

		setTimeout(function(){
			jQuery([document.documentElement, document.body]).animate({
				scrollTop: jQuery( `#${id} a[href="#"]` ).offset().top - 50
			}, 350 );
		}, 50 );

		if( ! canDismiss ) {
			return false;
		}

		jQuery( `#${id} a[href="#"]` ).on( 'click', function(){
			jQuery( `#${id}` ).remove();
		});
	},

	isEmail: function(email) {
		var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		return regex.test(email);
	},

	pctApiCall: function( data ) {
		return new Promise((resolve, reject) => {
			jQuery.ajax({
				type: 'POST',
				url: pctVars.ajax_url,
				dataType: 'json',
				cache: false,
				// contentType: 'application/json', 
				// data: JSON.stringify( data ),
				data: data,
				success: function( response ){
					resolve(response);
				},
				error: function( response ){
					console.log( '^^^^^^^^^^^^^^^^^' );
					console.log( response );
				},
			}).done(function(data, textStatus, jqXHR) {
				//console.log("Success: ", data);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log( '--------' );
				console.log("Error: ", jqXHR);
				console.log("Error: ", textStatus);
				console.log("Error: ", errorThrown);
			});
		});
	},
};

export { helpers };
